var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-md-flex "},[_c('package-info',{staticClass:"package-info",attrs:{"content":_vm.content}}),_c('div',{staticClass:"map rounded border w-100 "},[_c('z-map-expandable',{attrs:{"destinations":_vm.destinations}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }